import CourseDocumentPanel from './CourseDocumentPanel';

export default CourseDocumentPanel;
